import { Helmet } from "react-helmet-async";
import { useEffect, useState, useCallback } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
} from "@mui/material";

import Scrollbar from "../components/scrollbar";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
// ----------------------------------------------------------------------

export default function LeaderboardPage() {
  const [searchParams] = useSearchParams();
  const [competition, setCompetition] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (searchParams.has("type")) {
      const competition = searchParams.get("type");
      setCompetition(competition);
    }
  }, [searchParams]);

  const getRows = (competition) => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/leaderboard?competition=${competition}`)
      .then(function (response) {
        setLoading(false);
        setRows(response.data.leaderboard);
      });
  };

  const fn = useCallback(() => getRows(competition), [competition])
  useEffect(() => {
    if(competition) fn(competition)
  }, [competition, fn])

  return (
    <>
      <Helmet>
        <title> Leaderboard </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
          Leaderboard
          </Typography>
        </Stack>
        <Card>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>User Id</TableCell>
                      <TableCell>Rank</TableCell>
                      <TableCell>Username</TableCell>
                      <TableCell>FR Points</TableCell>
                      <TableCell>SR Points</TableCell>
                      <TableCell>S16 Points</TableCell>
                      <TableCell>EE Points</TableCell>
                      <TableCell>FF Points</TableCell>
                      <TableCell>CH Points</TableCell>
                      <TableCell>Total Points</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                      <TableRow>
                        <TableCell>{row.userId}</TableCell>
                        <TableCell>{row.rank}</TableCell>
                        <TableCell>{row.username}</TableCell>
                        <TableCell>{row.FRPoints}</TableCell>
                        <TableCell>{row.SRPoints}</TableCell>
                        <TableCell>{row.S16Points}</TableCell>
                        <TableCell>{row.EEPoints}</TableCell>
                        <TableCell>{row.FFPoints}</TableCell>
                        <TableCell>{row.CHPoints}</TableCell>
                        <TableCell>{row.points}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
